export const HAS_NO_DATA = 'hasNoData'
export const IS_LOADING = 'isLoading'
export const LOADING_FAILED = 'loadingFailed'
export const LOADING_SUCCEEDED = 'loadingSucceeded'
